/* tslint:disable */
/* eslint-disable */

/**
 * Which `Invoices` date column the date-range filter applies to.
 * `created` is always populated (including for pre-check invoices),
 * `date_financed` is populated only once financed.
 */
export enum ClientInvoiceExportDateField {
  Created = 'created',
  DateFinanced = 'date_financed'
}
